import 'vuetify/styles';

// Imports
import { camelize, h } from 'vue';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

// Icons
import * as mdiSvg from './mdi';

const customTheme = {
    dark: false,
    colors: {
      background: '#FFFFFF',
      surface: '#FFFFFF',
      primary: '#5FA624',
      'primary-darken-1': '#2F5312',
      secondary: '#03080b',
      'secondary-darken-1': '#000000',
      error: '#B00020',
      info: '#2196F3',
      success: '#71CF25',
      warning: '#FB8C00',
    },
}

export function installVuetify (app) {
    const vuetify = createVuetify({
        components: components,
        directives,
        icons: {
            defaultSet: 'mdi',
            sets: {
                mdi: {
                    component: props => {
                        const icon = mdiSvg[camelize(props.icon)]
                        return h(components.VSvgIcon, { ...props, icon })
                    },
                }
            }
        },
        theme: {
            defaultTheme: 'customTheme',
            themes: {
                customTheme,
            }
        }
    })
    
    app.use(vuetify);
}